import { db } from "../config/firebaseConfig"; // あなたのfirebase設定
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export const logChange = async ({
  projectId,
  target,
  field,
  masterID,
  uttID,
  utilityType,
  oldValue,
  newValue,
  userId,
  userName,
  timestamp
}) => {
  try {
    await addDoc(collection(db, "changeLogs"), {
      projectId,
      target,
      field,
      masterID,
      uttID,
      utilityType,
      oldValue,
      newValue,
      userId,
      userName,
      timestamp: serverTimestamp(),
    });
  } catch (error) {
    console.error("ログ保存に失敗しました:", error);
  }
};
